import { LegalNotice, SimpleTeaser } from 'cpfr-common';
import { HeroImage } from '@cp-shared-19/frontend-ui';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import React from 'react';

type LegalNoticeUIProps = {
    legalNotice?: LegalNotice;
};

export const LegalNoticeTeaserUI: React.FC<{ teaser?: SimpleTeaser }> = ({ teaser }) =>
    teaser ? (
        <HeroImage title={teaser.title} imageUrl={teaser.imageUrl} shallow={false} inverted={!!teaser.isInverted} />
    ) : null;

export const LegalNoticeContentUI: React.FC<{ content?: string }> = ({ content }) =>
    content ? (
        <ContentSection pageWrapSize="medium">
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </ContentSection>
    ) : null;

export const LegalNoticeUi: React.FC<LegalNoticeUIProps> = ({ legalNotice }) =>
    legalNotice ? (
        <>
            <LegalNoticeTeaserUI teaser={legalNotice.teaser} />
            <LegalNoticeContentUI content={legalNotice.content} />
        </>
    ) : null;
